import { render, staticRenderFns } from "./SalesReportReadItem.vue?vue&type=template&id=1b8953c8&scoped=true&"
import script from "./SalesReportReadItem.vue?vue&type=script&lang=js&"
export * from "./SalesReportReadItem.vue?vue&type=script&lang=js&"
import style0 from "./SalesReportReadItem.vue?vue&type=style&index=0&id=1b8953c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8953c8",
  null
  
)

export default component.exports